import PropTypes from 'prop-types';
import React from 'react';

/**
 * @param {Object} address
 * @param {String} address.street - street line 1
 * @param {String} address.streetLine2 - street line 2 (optional)
 * @param {String} address.city - address city
 * @param {String} address.state - address state/province
 * @param {String} address.zip - address zip code
 *
 * @returns address concatendated into a string, lines separated by "\n"s
 */
function formatAddress({ street, streetLine2, city, state, zip }) {
  return `${street}\n${streetLine2 ? `${streetLine2}\n` : ''}${city}, ${state} ${zip}`;
}

const NewLineText = ({ text = '' }) => {
  const brokenText = text.split('\n').map((item, index) => (index === 0 ? item : [<br key={index} />, item]));
  return <p>{brokenText}</p>;
};

// component to render an address
const Address = ({ address }) => <NewLineText text={formatAddress(address)} />;

Address.propTypes = {
  address: PropTypes.shape({
    street: PropTypes.string,
    streetLine2: PropTypes.string,
    city: PropTypes.string,
    state: PropTypes.string,
    zip: PropTypes.string,
  }),
};

export default Address;
